import { axiosCompanyPortalInstance } from "./";

/**
 * Company Portal events API (PROLINE-2274).
 * Paths are relative to `REACT_APP_COMPANY_PORTAL_API_BASE_URL` (typically `.../api/company_portal/v1`).
 */

const getCompanyPortalEventsList = (params = {}) =>
  axiosCompanyPortalInstance.get("/events", { params });

const getCompanyPortalEvent = (id) =>
  axiosCompanyPortalInstance.get(`/events/${id}`);

const createCompanyPortalEvent = (data) =>
  axiosCompanyPortalInstance.post("/events", data);

const updateCompanyPortalEvent = ({ data, id }) =>
  axiosCompanyPortalInstance.patch(`/events/${id}`, data);

const publishCompanyPortalEvent = (id) =>
  axiosCompanyPortalInstance.post(`/events/${id}/publish`);

const cancelCompanyPortalEvent = (id) =>
  axiosCompanyPortalInstance.post(`/events/${id}/cancel`);

const deleteCompanyPortalEvent = (id) =>
  axiosCompanyPortalInstance.delete(`/events/${id}`);

const getCompanyPortalEventConflictingResources = ({ id, params }) =>
  axiosCompanyPortalInstance.get(`/events/${id}/conflicting_resources`, {
    params,
  });

/** PROLINE-3179 — event-level automatic-deduction flags. */
const updateCompanyPortalEventAutoDeduction = ({ id, params }) =>
  axiosCompanyPortalInstance.patch(`/events/${id}/update_auto_deduction`, params);

/** PROLINE-3796 — `calculate_by_checkin_only` ("Pay Full Scheduled Shift"). */
const updateCompanyPortalEventCalculationSettings = ({ id, params }) =>
  axiosCompanyPortalInstance.patch(`/events/${id}/update_calculation_settings`, params);

const getCompanyPortalLookups = (keys = []) =>
  axiosCompanyPortalInstance.get("/lookups", {
    params: { keys: keys.join(",") },
  });

export {
  getCompanyPortalEventsList,
  getCompanyPortalEvent,
  createCompanyPortalEvent,
  updateCompanyPortalEvent,
  publishCompanyPortalEvent,
  cancelCompanyPortalEvent,
  deleteCompanyPortalEvent,
  getCompanyPortalEventConflictingResources,
  updateCompanyPortalEventAutoDeduction,
  updateCompanyPortalEventCalculationSettings,
  getCompanyPortalLookups,
};
